import React, { Component } from "react";
import { Link } from 'react-router-dom';
import Header from './../../Header';
import Loader from './../../Loader';
import Menu from './../../Menu';
import NextPrev from "./NextPrev";
import $ from "jquery";
import './../../../assets/css/question.css';
import { CONFIG } from './../../../helpers/Common';
import {SURGEON} from './../../../services/Surgeon';

class CheifComplainLocation extends Component {

    constructor(props)
    {
        super(props);
        if(this.props.profileData=="")
        {
            window.location.replace('/')
        }
        
        this.state = {
            isInit:true,
            complainDetails:this.props.getComplainData.complainTypeDetails,
            profileData:this.props.profileData,
            all_complaints:this.props.isComplainMaster ? [] : JSON.parse(this.props.profileData.all_complaints) ,
            imageView:"front",
            currentImage:"",
            coordinate_x:"",
            coordinate_y:"",
            nextStep:4,
            prevStep:2,
            imgPath: CONFIG.COMPLAIN_IMAGE_PATH,
            selectedLocation:[]
        };
        this.handlePrevAction   = this.handlePrevAction.bind(this);
        this.handleAction       = this.handleAction.bind(this);
        this.markPositionOld    = this.markPositionOld.bind(this);

    }

    componentWillMount() {

        localStorage.setItem("saveQuest",true);

        let complainData            = this.state.complainDetails;
        let complainLocationData    = this.props.getComplainLocationData;
        console.log('Here all_complaints in complainLocation .js',this.state.all_complaints)
        if(this.state.all_complaints.length>0){

            for (let i = 0; i < this.state.all_complaints.length; i++) {
                for (let index = 0; index < this.state.all_complaints[i].image_and_points.length; index++) {
                    if(this.props.getComplainData.complain_types === this.state.all_complaints[i].image_and_points[index].complain_type){
                        console.log('Item Matched to update state')
                        this.setState({
                            ...this.state,all_complaints:this.state.all_complaints,selectedLocation:this.state.all_complaints[i].image_and_points[index].complainLocationData.selectedLocation
                        });
                        return;
                    }
                }
            }
            // this.state.all_complaints[this.state.all_complaints.length-1].image_and_points.forEach((item,key)=>{
            //     console.log('In loop')
            //     console.log('props selected complain type',this.props.getComplainData.complain_types)
            //     console.log('item to match complain type',item.complain_type)

            //     if(this.props.getComplainData.complain_types === item.complain_type){
            //         console.log('Item Matched to update state')
            //         this.setState({
            //             ...this.state,all_complaints:this.state.all_complaints,selectedLocation:item.complainLocationData.selectedLocation
            //         });
            //     }
            // });

        }
        // if(all_complaints){
        //
        //     this.setState({
        //         ...this.state,all_complaints,selectedLocation:all_complaints[0].image_and_points[0].complainLocationData.selectedLocation
        //     })
        // }

        if(complainLocationData)
        {
            this.setState({
                coordinate_x    :complainLocationData.coordinate_x,
                coordinate_y    :complainLocationData.coordinate_y,
                imageView       :complainLocationData.image_view,
                currentImage    :complainLocationData.image,
                picCoordinates  :complainLocationData.picCoordinates
            });

        }
        else
        {
            this.setState({
                currentImage    :complainData.image_front,
            });
        }
        this.resize();
    }

    handleImageView = (e)=>{
        if(this.state.imageView=='front')
        {
            this.setState({
                imageView :'back',
                currentImage    : this.state.complainDetails.image_back,
            });
        }
        else
        {
            this.setState({
                imageView :'front',
                currentImage    : this.state.complainDetails.image_front,
            });
        }
        $(".marker").remove();
        this.setState({
            coordinate_x:'',
            coordinate_y:'',
        })
    }

    handleAction = (e)=>{

        if(this.state.selectedLocation === undefined || this.state.selectedLocation.length == 0)
        {
            alert("Please select area in Image");
        }
        else
        {
            $(".marker").remove();
            let data = ({
                image_view      : this.state.imageView,
                image           : this.state.currentImage,
                selectedLocation: this.state.selectedLocation,
                coordinate_x    : this.state.coordinate_x,
                coordinate_y    : this.state.coordinate_y,
            });
            $(".marker").remove();
            this.props.setComplainLocation(data);
            this.props.handleNextPrev(this.state.nextStep);
        }
        $(".marker").remove();

    }

    handlePrevAction = (e)=>{
        this.props.handleNextPrev(this.state.prevStep);
        $(".marker").remove();
    }

    changeImage = () => {
        $(".marker").remove();
        let tempImage = !this.state.frontImage;
        this.setState({
            frontImage: tempImage
        });
    };

    resize = () => {

        // if(this.state.coordinate_x !== "" || this.state.coordinate_y !== "") this.markPositionOld();

        if(this.state.selectedArray === undefined || this.state.selectedArray.length == 0){

        }else{
            this.markPositionOld();
        }
    };

    componentDidMount() {
        let complainData            = this.state.complainDetails;
        if(this.props.isModify)
        {
            SURGEON.getPatientComplainDetail(this.props.patientId,complainData.id).then(res => {
                if(res.data.header.error==0)
                {

                    let complainTypes       = res.data.body.details;
                    this.setState({
                        coordinate_x    :parseFloat(complainTypes.coordinate_x),
                        coordinate_y    :parseFloat(complainTypes.coordinate_y),
                        imageView       :complainTypes.image_view,
                    });
                    if(complainTypes.image_view=='front')
                    {
                        this.setState({
                            imageView :'front',
                            currentImage    : this.state.complainDetails.image_front,
                        });
                    }
                    else
                    {
                        this.setState({
                            imageView :'back',
                            currentImage    : this.state.complainDetails.image_back,
                        });
                    }
                    this.props.setNarrativeId(complainTypes.id);
                    this.resize();
                }
            }).catch(err => {
                return err;
            });
        }
        this.resize();
        window.addEventListener('resize', this.resize)

    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.resize)
    }

    mark(markerId, picCoordinates, top, left) {
        let markerRadius = 13;
        // $(".marker").remove();
        $(".male-img").append(
            $('<div class="marker marker'+ markerId + '"></div>').css({
                position: "absolute",
                top: `calc(${top}px - (${markerRadius}px / 2))`,
                left: `calc(${left}px - (${markerRadius}px / 2))`,
                width: markerRadius + 'px',
                height: markerRadius + 'px',
                backgroundColor: "#990000",
                borderRadius: '50%',
                display: 'inline-block',
            })
        );
    }

    markPositionOld = () => {
        // var picCoordinates = document.getElementById('pic').getBoundingClientRect();
        // this.mark(picCoordinates, this.state.coordinate_y, this.state.coordinate_x);

        var picCoordinates = $('#pic').parent('.male-img')[0].getBoundingClientRect();
        this.state.selectedLocation.map((item)=>{
            return(this.mark(item.picCoordinates, item.coordinate_y, item.coordinate_x));
        });
    };

    markPosition = ev => {
        var picCoordinates = $('#pic').parent('.male-img')[0].getBoundingClientRect();
        let offsetX = ev.pageX - picCoordinates.x;
        let offsetY = ev.pageY - picCoordinates.y;
        // this.mark(picCoordinates, offsetY, offsetX);
        this.setState({
            coordinate_x: offsetX,
            coordinate_y: offsetY,
        });

        this.setState({...this.state,selectedLocation:[...this.state.selectedLocation,this.setNewSelectedLocation(picCoordinates,offsetX,offsetY,this.makeSelectedItemId(this.state.selectedLocation))]});
    };

    setNewSelectedLocation=(picCoordinates,x,y,id)=>{

        return (
            {
                id,
                picCoordinates,
                coordinate_x:x,
                coordinate_y:y,
            }
        );

    };

    makeSelectedItemId=(selectedArray)=>{

        if (selectedArray === undefined || selectedArray.length == 0) {
            return 1;
        }else{
            return  selectedArray[selectedArray.length-1].id +1;
        }
    };

    makeSeletedItemList=(selectedArray)=>{
        if (selectedArray === undefined || selectedArray.length == 0) {
            return null;
        }else{
            return (selectedArray.map((item)=>{
                this.mark(item.id,item.picCoordinates, item.coordinate_y, item.coordinate_x);
                return (<div className="point-close"><div>POINT {item.id}</div>
                    <span onClick={(event) => {
                        $(".marker" + item.id).remove();
                        this.setState({
                            ...this.state, selectedLocation: this.state.selectedLocation.filter((i) => {
                                return item.id !== i.id;
                            })
                        });
                    }}>&#10060;</span></div>)
            }));
        }
    };

    render() {

        if(this.state.isInit){
            if(this.props.getComplainLocationData.selectedLocation === undefined || this.props.getComplainLocationData.selectedLocation.length == 0){}else{
                this.setState({...this.state,selectedLocation:this.props.getComplainLocationData.selectedLocation,isInit:false});
            }
        }

        return (

            <React.Fragment>
                <Header title="Patient Symptoms Narrative" titleImage="ic-medical-result.png" />
                <Menu />
                <section className="chief-complain sec--question">
                    <div className="questionrow">
                        <div className="question">
                            <label>Question</label>
                            <h3>What is the location of {this.state.complainDetails.name}?</h3>
                        </div>
                    </div>
                    <div className="male-model-complain">
                        <div className="container">
                            <div className="male-img">
                                <img  onClick={this.markPosition} id="pic" src={this.state.imgPath+this.state.currentImage} alt=""/>
                                {/* <div className="view-btn">
                                <Link to="#" onClick={this.handleImageView} >
                                    <img src={require("../assets/img/icons/ic-refresh.png")} alt=""/>
                                </Link>
                            </div> */}

                                <div style={{ position: "absolute", top: 10, left: "100%", marginLeft: 15 }}>
                                    {this.makeSeletedItemList(this.state.selectedLocation)}
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <NextPrev handleNextAction={this.handleAction} next={this.state.nextStep} prev={this.state.prevStep} handlePrevAction={this.handlePrevAction} />

            </React.Fragment>
        );
    }
}

export default CheifComplainLocation;